import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { filterRestaurantsByUser } from '../utils/restaurantFilter';
import { api } from '../utils/apiClient';
import type { Restaurant } from '../types';

export function useRestaurants() {
  const { user } = useAuth();
  const [restaurants, setRestaurants] = useState<Restaurant[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchRestaurants = useCallback(async (): Promise<Restaurant[]> => {
    setLoading(true);
    setError('');
    try {
      const { data } = await api.get<Restaurant[]>('/api/restaurants');
      const filtered = filterRestaurantsByUser(data, user) as Restaurant[];
      setRestaurants(filtered);
      return filtered;
    } catch {
      setError('Failed to load restaurants');
      return [];
    } finally {
      setLoading(false);
    }
  }, [user]);

  return { restaurants, loading, error, fetchRestaurants };
}
